import script from "./CategoryIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryIcon.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryIcon.vue?vue&type=style&index=0&id=554400ce&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554400ce"]])

export default __exports__